/**
 * Helpers pour les numéros de téléphone.
 * Les numéros sont saisis via le composant partagé PhoneNumberInput
 * (react-phone-number-input) et stockés au format E.164, ex. "+213555123456".
 */

import { isValidPhoneNumber } from "react-phone-number-input";

/**
 * Règle de validation antd réutilisable pour un champ téléphone :
 * numéro requis (optionnel) + format réel valide pour le pays détecté depuis
 * l'indicatif (`isValidPhoneNumber` de libphonenumber-js).
 *
 * @param {(key: string, opts?: object) => string} translate  fonction i18n `t`
 * @param {boolean} [required=true]
 * @return {{ validator: (rule: object, value: string) => Promise<void> }}
 */
export const buildPhoneRule = (translate, required = true) => ({
  validator: (_rule, value) => {
    if (!value) {
      return required
        ? Promise.reject(
            translate("common.phoneInput.error.required", {
              defaultValue: "Veuillez saisir un numéro de téléphone.",
            })
          )
        : Promise.resolve();
    }
    return isValidPhoneNumber(value)
      ? Promise.resolve()
      : Promise.reject(
          translate("common.phoneInput.error.invalid", {
            defaultValue:
              "Numéro de téléphone invalide pour le pays sélectionné.",
          })
        );
  },
});
